// extracted by mini-css-extract-plugin
export default {"cancelBtn":"ConfirmDeleteModal_cancelBtn__-oiGe","confirmDanger":"ConfirmDeleteModal_confirmDanger__nFMyP","modalContentWrapper":"ConfirmDeleteModal_modalContentWrapper__F4Hkx"};